import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { TokenInterceptorService } from './TokenInterceptorService';
import { VersionsInterceptorService } from './data-cache/VersionsInterceptorService';
import { MaintenanceInterceptorService } from './MaintenanceInterceptorService';

export const interceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: MaintenanceInterceptorService, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: VersionsInterceptorService, multi: true },
];